import { lazy, Suspense } from "react";

const Signup = lazy(() => import("./Signup"));
const SignupSuccess = lazy(() => import("./SignupSuccess"));
const Signin = lazy(() => import("./Signin"));
const ForgotPassword = lazy(() => import("./ForgotPassword"));
const ChangePassword = lazy(() => import("./ChangePassword"));
const Error404 = lazy(() => import("./Error"));
const Forbidden = lazy(() => import("./Forbidden"));
const ResetPassword = lazy(() => import("./ResetPassword"));
const ExternalAuth = lazy(() => import("./ExternalAuth"));

const sessionsRoutes = [
  {
    path: "/login",
    element: (
      <Suspense>
        <Signin />
      </Suspense>
    ),
  },
  {
    path: "/cambio-password",
    element: (
      <Suspense>
        <ChangePassword />
      </Suspense>
    ),
  },
  {
    path: "/registrati",
    element: (
      <Suspense>
        <Signup />
      </Suspense>
    ),
  },
  {
    path: "/registrazione-ok",
    element: (
      <Suspense>
        <SignupSuccess />
      </Suspense>
    ),
  },
  {
    path: "/password-dimenticata",
    element: (
      <Suspense>
        <ForgotPassword />
      </Suspense>
    ),
  },
  {
    path: "/reset-password",
    element: (
      <Suspense>
        <ResetPassword />
      </Suspense>
    ),
  },
  {
    path: "/404",
    element: (
      <Suspense>
        <Error404 />
      </Suspense>
    ),
  },
  {
    path: "/forbidden",
    element: (
      <Suspense>
        <Forbidden />
      </Suspense>
    ),
  },
  {
    path: "/external-auth",
    element: (
      <Suspense>
        <ExternalAuth />
      </Suspense>
    ),
  },
];

export default sessionsRoutes;
